import { regexName, regexEmail, documentCheck } from "../../../util/errorHandling"
import {
  isTenantRequiredForType,
  optionalTenantTypes,
  rentOutTypes,
  requiredTenantTypes,
  visitTypeServices,
} from "./appointmentFormDefaults"

const validateRealtiesPrivateArea = (realties) => {
  return realties.every((realty) => realty.private_area_meters !== null && realty.private_area_meters !== 0)
}

const validateRealtyAvailability = (realties) => {
  return realties.every((realty) => realty.available === true)
}

const validateRealtyFurnished = (realties) => {
  return realties.every((realty) => realty.furnished !== null)
}

const validateRealtyTrousseau = (realties) => {
  return realties.every((realty) => realty.trousseau !== null)
}

const validateRealtyPaintingStatus = (realties) => {
  return realties.every((realty) => realty.painting_status !== null)
}

export const validateRealtyType = (realties) => {
  return realties.every((realty) => realty.type !== null)
}

export const validateServiceDetails = (appointmentFields) => {
  const { type, real_estate_branch_id, worker_type, inspector_id } = appointmentFields

  if (!type || !real_estate_branch_id) {
    return false
  }

  return true
}

export const validateDateTime = (appointmentFields) => {
  const { date } = appointmentFields
  return date && date?.length >= 11
}


export const validateRealties = (appointmentFields, baseReportRequired = false) => {
  const { realties, realties_complete, base_report_id } = appointmentFields

  return (
    realties.length >= 1 &&
    (!baseReportRequired || !!base_report_id) &&
    validateRealtiesPrivateArea(realties_complete) &&
    validateRealtyAvailability(realties_complete) &&
    validateRealtyFurnished(realties_complete) &&
    validateRealtyTrousseau(realties_complete) &&
    validateRealtyPaintingStatus(realties_complete)
    //  && validateRealtyType(realties_complete)
  )
}

export const validateMeetingLocation = (appointmentFields, hasMeetingLocation) => {
  if (!hasMeetingLocation) return true

  let {
    id,
    address,
    meeting_location,
  } = appointmentFields.meeting_location_options

  if (meeting_location === null) return false

  if (meeting_location === 'OTHER' && address === undefined) return false

  if (meeting_location !== 'OTHER' && id === undefined) return false

  return true
}

export const validateKeyLocation = (appointmentFields) => {
  const {
    id,
    address,
    key_picker,
    key_location,
  } = appointmentFields.key_location_options

  if (key_picker === null) return false

  if (key_location === null) return false

  if (key_location === 'OTHER' && address === null) return false

  if (key_location !== 'OTHER' && id === null) return false

  return true
}

export const validateVisitorInfo = (appointmentFields) => {
  const {
    type,
    visitor_name,
    visitor_mail,
    visitor_phone,
    visitor_document,
    visitor_birth_date,
  } = appointmentFields

  const isOptionalTenant = optionalTenantTypes.includes(type)

  if (!isOptionalTenant && isTenantRequiredForType(type)) {
    if (!regexName.test(visitor_name.trim())) return false
    if (visitTypeServices.includes(type) && !regexEmail.test(visitor_mail)) return false
    if (!visitor_phone || visitor_phone.length <= 9) return false
  }

  if (!isOptionalTenant && (rentOutTypes.includes(type) || requiredTenantTypes.includes(type))) {
    if (!visitor_document || typeof documentCheck(visitor_document) !== 'boolean') return false
    if (!visitor_birth_date || !visitorBirthDateCheck(visitor_birth_date)) return false
  }

  if (type !== 'VISIT' || !rentOutTypes.includes(type)) {
    const visitorPhone = visitor_phone ? visitor_phone.replace(/\D/g, '') : ''

    // name ----------------------------------------------------
    if (visitor_name && !regexName.test(visitor_name.trim())) return false
    // /name ---------------------------------------------------

    // email ---------------------------------------------------
    if (visitor_mail && !regexEmail.test(visitor_mail)) return false
    // /email --------------------------------------------------

    // phone ---------------------------------------------------
    if (visitorPhone && visitorPhone.length <= 9) return false
    // /phone ---------------------------------------------------

    // document -------------------------------------------------
    if (visitor_document) {
      if (typeof documentCheck(visitor_document) !== 'boolean') return false
    }
    // /document ------------------------------------------------

    // Brazil: phone and document become required when visitor name is filled
    const isBrazil = localStorage.getItem('user_country') === 'BR'

    const isAnyVisitorFieldFilled = !!(visitor_name || visitor_mail || visitor_phone || visitor_document)

    if (!isOptionalTenant && isBrazil && isAnyVisitorFieldFilled) {
      const phoneDigits = visitor_phone ? visitor_phone.replace(/\D/g, '') : ''

      if (!visitor_name || !regexName.test(visitor_name.trim())) return false
      if (!phoneDigits || phoneDigits.length <= 9) return false
      if (!visitor_document || typeof documentCheck(visitor_document) !== 'boolean') return false
    }
    // /Brazil --------------------------------------------------

    // birth date -----------------------------------------------
    if (visitor_birth_date) {
      return visitorBirthDateCheck(visitor_birth_date)
    }
    // /birth date ----------------------------------------------
  }

  return true
}

const visitorBirthDateCheck = (birthDate) => {
  if (birthDate.includes('undefined')) return false

  const splittedDateFull = birthDate.split('T')
  const splittedDate = splittedDateFull[0].split('-')
  const parsedDate = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`

  if (parsedDate.length <= 9) return false

  let now = new Date()
  let currentYear = now.getFullYear()
  let parts = parsedDate.split('/')

  let day = parseInt(parts[0])
  let month = parseInt(parts[1])
  let year = parseInt(parts[2])

  if (!day || (day < 1 || day > 31)) return false
  if (!month || (month < 1 || month > 12)) return false
  if (!year || (currentYear - year < 0 || currentYear - year > 500)) return false

  return true
}
